/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { Environment } from '@jira/platform__tenant-context-types/src/tenant-context.tsx';
import { useTenantContext } from '../tenant-context/index.tsx';

const ENVIRONMENT = {
	STAGING: 'staging',
	DEV: 'dev',
	LOCAL: 'local',
	PROD: 'prod',
} as const;

type ENVIRONMENT = (typeof ENVIRONMENT)[keyof typeof ENVIRONMENT];

/**
 * Returns the current environment (prod, staging, dev, or local).
 *
 * @agent-skills: tenant-context
 */
export const useEnvironment = (): Environment => {
	const tenantContext = useTenantContext();
	return tenantContext?.environment || ENVIRONMENT.PROD;
};

/**
 * Returns true if the environment is staging, dev, or local.
 *
 * @agent-skills: tenant-context
 */
export const useIsStagingOrDevOrLocal = (): boolean => {
	const env = useEnvironment();
	return env === ENVIRONMENT.STAGING || env === ENVIRONMENT.DEV || env === ENVIRONMENT.LOCAL;
};
